import { useEffect, useState } from "react";

export const useRootFontSize = () => {
  const [rootFontSize, setRootFontSize] = useState(16);

  useEffect(() => {
    const html = document.querySelector("html")!;

    const htmlFontSize = Number(
      window
        .getComputedStyle(html)
        .getPropertyValue("font-size")
        .replace("px", "")
    );

    setRootFontSize(htmlFontSize);
  }, []);

  return rootFontSize;
};
